import SocialProjectManager from '../../clients/abdaSocialProjectManager'
import { merge } from 'lodash'

const resourceName = 'gymratingjump'

const GetAll = (criteria, pagination) => SocialProjectManager.get(resourceName, { 
  params: merge(criteria, pagination) 
})

const GetById = (id, pagination) => SocialProjectManager.get(`${resourceName}/${id}`, { 
  params: merge(pagination) 
})

const GetGymRatingJumpByGymRatingId = (gymratingId, pagination) => SocialProjectManager.get(`${resourceName}/gymrating/${gymratingId}`, { 
  params: merge(pagination) 
})

const Update = data => SocialProjectManager.put(`${resourceName}/${data.id}`, data)

const Delete = id => SocialProjectManager.delete(`${resourceName}/${id}`)

const ExportExcelJrAndSenior = (id, classAverage, lit, category, className) => SocialProjectManager.get(`${resourceName}/download-excel-jump/${id}/avg/${classAverage}/literature/${lit}/category/${category}`, { 
  params: {className}
})

const GymRatingJumpRepository = {
  GetById,
  GetAll, 
  GetGymRatingJumpByGymRatingId,
  Update,
  Delete,
  ExportExcelJrAndSenior,
}

export default GymRatingJumpRepository